export default __webpack_public_path__ + "static/media/CL12.3c5d3426.mp3";